import * as yup from "yup";

// Schéma de validation dynamique pour le formulaire d'inscription
export const getInscriptionSchema = (emailValidated: boolean, isFranceOrAssimile: boolean, sirenApiError?: string | null) => {
  return yup.object().shape({
    Email: yup.string().email("Email invalide").required("Email requis"),
    IdPays: emailValidated 
      ? yup.number().required("Pays requis").transform((value) => (isNaN(value) ? undefined : value))
      : yup.number().optional().transform((value) => (isNaN(value) ? undefined : value)),
    Siren: emailValidated && isFranceOrAssimile 
      ? yup.string()
          .required("SIREN requis pour la France")
          .length(9, "Le SIREN doit contenir 9 chiffres")
          .test("api-validation", sirenApiError || "", function(value) {
            // Si une erreur API existe, le champ est invalide
            if (sirenApiError && value && value.length === 9) {
              return this.createError({ message: sirenApiError });
            }
            return true;
          })
      : yup.string().optional(),
    RaisonSociale: emailValidated ? yup.string().required("Raison sociale requise") : yup.string().optional(),
    Adresse: emailValidated ? yup.string().required("Adresse requise") : yup.string().optional(),
    CodePostal: yup.string().optional(),
    Ville: emailValidated ? yup.string().required("Ville requise") : yup.string().optional(),
    SiteInternet: yup.string().optional().matches(
      /^$|^(https?:\/\/)?([\w\u00C0-\u00FF-]+(\.[\w\u00C0-\u00FF-]+)+)(:\d+)?(\/[\w\u00C0-\u00FF\-._~:/?#[\]@!$&'()*+,;=%]*)?$/,
      "Veuillez entrer une URL valide (ex: https://editeurspros.electre.com/)"
    ),
    IdCivilite: emailValidated ? yup.number().required("Civilité requise").transform((value) => (isNaN(value) ? undefined : value)) : yup.number().optional().transform((value) => (isNaN(value) ? undefined : value)),
    Nom: emailValidated ? yup.string().required("Nom requis") : yup.string().optional(),
    Prenom: emailValidated ? yup.string().required("Prénom requis") : yup.string().optional(),
    // Validation internationale pour les numéros de téléphone (format E.164)
    Telephone: yup.string().optional().matches(
      /^$|^\+[1-9]\d{1,14}$/,
      "Format de téléphone invalide. Veuillez sélectionner un pays et saisir un numéro valide."
    ),
    Fonction: emailValidated ? yup.string().required("Fonction requise") : yup.string().optional(),
    GLNEditeur: yup.string().optional().matches(/^\d{13}$|^$/, "Le GLN doit contenir 13 chiffres"),
    GLNDiffuseur: yup.string().optional().matches(/^\d{13}$|^$/, "Le GLN doit contenir 13 chiffres"),
    MarquePrincipale: yup.string().optional(),
    IdSecteurActivite: emailValidated 
      ? yup.number().required("Secteur d'activité requis").transform((value) => (isNaN(value) ? undefined : value))
      : yup.number().optional().transform((value) => (isNaN(value) ? undefined : value)),
    IndicatifISBN: yup.string().optional(),
    ISBN1: yup.string().optional(),
    ISBN2: yup.string().optional(),
    ISBN13EANComplet: yup.string().optional(),
    GLNDistributeur: yup.string().optional().matches(/^\d{13}$|^$/, "Le GLN doit contenir 13 chiffres"),
    Message: yup.string().optional().max(600, "Le message ne doit pas dépasser 600 caractères"),
    PiecesJustificatives: emailValidated 
      ? yup.array().min(1, "Au moins une pièce justificative est requise").required("Pièces justificatives requises")
      : yup.array().optional(),
    AcceptationCGU: emailValidated
      ? yup.boolean().oneOf([true], "Vous devez accepter la convention").required("Vous devez accepter la convention")
      : yup.boolean().optional(),
  });
};
